<template>
  <div>
    <my-upload
      langType="en"
      field="img"
      @crop-success="cropSuccess"
      @crop-upload-success="cropUploadSuccess"
      @crop-upload-fail="cropUploadFail"
      v-model="show"
      :width="300"
      :height="300"
      :params="params"
      :headers="headers"
      img-format="png"
      :noSquare="true"
    >
    </my-upload>
    <b-card
      img-top
      class="card-img-prof text-center"
      body-class="body-card-prof"
    >
      <!-- :title="`${profile.firstname} ${profile.lastname}`" -->
      <!-- :img-src="profile.imgURL ? profile.imgURL : `resources/images/default/profile.png`" -->
      <!-- img-alt="Image" -->
      <div class="wrapper-pp" style="position:relative">
        <b-card-img
          class="profile-picture"
          img-alt="Image"
          :src="
            imgDataUrl
              ? imgDataUrl
              : this.$store.getters['user/profile'].imgURL
              ? this.$store.getters['user/profile'].imgURL
              : `resources/images/default/profile.png`
          "
        />
        <div class="update-profile-btn" @click="toggleShow">
          <div class="fa fa-camera"></div>
          <div>
            {{ profile.imgURL ? "Update Picture" : "Add Picture" }}
          </div>
        </div>
      </div>
      <b-card-title :title="`${profile.firstname} ${profile.lastname}`" />
      <b-container>
        <b-row>
          <b-col
            v-for="(aSphere, index) in spheres"
            :key="index"
            cols="3"
            style="padding-left: 0;padding-right:0;margin-bottom:15px;"
          >
            <b-button
              :class="`${$style.sphere} ${aSphere.classes}`"
              @click="handleFilterFocus(aSphere)"
            >
              <!-- {{ shefPercentage(aSphere.sphere) }}% -->
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-card>
    <b-card title="">
      <b-card-text>
        <b
          >Connected Since
          {{ new Date(profile._created_at.toDate()).getFullYear() }}</b
        >
      </b-card-text>
      <b-card-text v-if="profile.language">
        Language: <b>{{ profile.language }}</b>
      </b-card-text>
      <b-card-text v-if="profile.location">
        Location: <b>{{ profile.location }}</b>
      </b-card-text>
    </b-card>
    <b-card title="Main Line" v-if="profile.mainline">
      <b-card-text>
        {{ profile.mainline }}
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import MyUpload from "vue-image-crop-upload";
import firebase from "firebase";

export default {
  components: {
    MyUpload
  },
  props: {},
  methods: {
    shefPercentage(sphere) {
      return this.profile.shef[sphere];
    },
    toggleShow() {
      this.show = !this.show;
    },
    cropSuccess(imgDataUrl, field) {
      this.imgDataUrl = imgDataUrl;
      this.updateProfileImage(imgDataUrl);
    },
    cropUploadSuccess(jsonData, field) {
      console.log("-------- upload success --------");
      console.log(jsonData);
      console.log("field: " + field);
    },
    cropUploadFail(status, field) {
      console.log("-------- upload fail --------");
      console.log(status);
      console.log("field: " + field);
    },
    updateProfileImage(imgDataUrl) {
      console.log(imgDataUrl, "ini di popipipipip");
      //Upload to server --
      //TODO:Move to store?
      var storageRef = firebase
        .storage()
        .ref(`profile_img/${this.$store.state.user.user.uid}`);

      var metadata = {
        contentType: "image/jpeg"
      };
      var uploadTask = storageRef.putString(imgDataUrl, "data_url");

      uploadTask.on(
        "state_changed",
        snapshot => {
          var progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log("Upload is " + progress + "% done");
          switch (snapshot.state) {
            case firebase.storage.TaskState.PAUSED: // or 'paused'
              console.log("Upload is paused");
              break;
            case firebase.storage.TaskState.RUNNING: // or 'running'
              console.log("Upload is running");
              break;
          }
        },
        error => {
          console.log("Error uploading image: ", error);
        },
        () => {
          uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
            this.$store
              .dispatch("user/updateProfile", { imgURL: downloadURL })
              .then(() => {
                this.$store.dispatch("user/getProfile").then(() => {
                  console.log("successfully saved at", downloadURL);
                });
              });
          });
        }
      );
    }
  },
  computed: {
    ...mapGetters({
      profile: "user/profile"
    })
  },
  data: function() {
    return {
      spheres: [
        {
          imgURL: "/resources/images/focus/sphere_spiritual.png",
          sphere: "s",
          name: "(S)piritual",
          definition:
            "relating to or affecting the human spirit or soul as opposed to material or physical things.",
          classes: "bg-spiritual border-spiritual",
          fontAwesome: "fa fa-sun-o",
          colorPrimary: "#185ace",
          colorSecondary: "#3c78d8",
          variant: "primary",
          variantName: "primary"
        },
        {
          imgURL: "/resources/images/focus/sphere_health.png",
          sphere: "h",
          name: "(H)ealth",
          definition: "a person's mental or physical condition.",
          classes: "bg-health border-health",
          fontAwesome: "fa fa-heartbeat",
          colorPrimary: "#9c0709",
          colorSecondary: "#cc0000",
          danger: "primary",
          variantName: "danger"
        },
        {
          imgURL: "/resources/images/focus/sphere_education.png",
          sphere: "e",
          name: "(E)ducation",
          definition: "an enlightening experience",
          classes: "bg-education border-education",
          fontAwesome: "fa fa-graduation-cap",
          colorPrimary: "#c09206",
          colorSecondary: "#f1c232",
          variant: "warning",
          variantName: "warning"
        },
        {
          imgURL: "/resources/images/focus/sphere_finance.png",
          sphere: "f",
          name: "(F)inance",
          definition: "the monetary resources and affairs of a person",
          classes: "bg-finance border-finance",
          fontAwesome: "fa fa-dollar",
          colorPrimary: "#37761d",
          colorSecondary: "#6aa84f",
          variant: "success",
          variantName: "success"
        }
      ],
      show: false,
      imgDataUrl: "",
      params: {
        token: "123456798",
        name: "avatar"
      },
      headers: {
        smail: "*_~"
      }
    };
  }
};
</script>
<style lang="scss" module>
@import "./style.module.scss";
</style>
<style scoped>
.card-img-prof .wrapper-pp {
  margin: 30px auto 15px auto;
}
.card-img-prof img {
  width: 171px;
  border-radius: 50%;
  height: 171px;
}
.body-card-prof {
  padding: 0 15px;
}
.body-card-prof h4 {
  color: #272f75 !important;
  font-weight: bold;
}
.update-profile-btn {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: none;
  background-color: rgba(255, 255, 255, 0.7);
  padding-bottom: 15px;
  color: #272f75;
  font-weight: bold;
  cursor: pointer;
}
.profile-picture:hover + .update-profile-btn,
.update-profile-btn:hover {
  display: block;
}
/* .update-profile-btn:hover {
    display: block;
  } */
</style>
